import React from 'react';
import { useI18n } from '../../lib/i18n';
import { Reveal } from '../ui/Reveal';
import { XIcon, CheckIcon } from 'lucide-react';
export function BeforeAfter() {
  const {
    t
  } = useI18n();
  const beforeItems = [t('b1'), t('b2'), t('b3'), t('b4')];
  const afterItems = [t('a1'), t('a2'), t('a3'), t('a4')];
  return <section className="py-24 md:py-32 relative bg-luxury-ivory" data-id="element-48">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-49">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-50">
          {/* Before Card */}
          <Reveal data-id="element-51">
            <div className="bg-luxury-warmgray/40 p-10 md:p-12 rounded-[2rem] border border-luxury-taupe/15 relative overflow-hidden group" data-id="element-52">
              <div className="absolute top-0 left-0 w-full h-1 bg-red-800/20" data-id="element-53" />
              <h3 className="text-sm font-medium text-luxury-stone uppercase tracking-widest mb-10 flex items-center gap-3" data-id="element-54">
                <span className="w-8 h-px bg-luxury-stone/30" data-id="element-55" />
                {t('baBefore')}
              </h3>
              <ul className="space-y-6" data-id="element-56">
                {beforeItems.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-57">
                    <div className="mt-0.5 bg-red-100/50 p-1 rounded-full shrink-0" data-id="element-58">
                      <XIcon className="w-4 h-4 text-red-500/60" data-id="element-59" />
                    </div>
                    <span className="text-luxury-stone font-light leading-relaxed" data-id="element-60">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          {/* After Card */}
          <Reveal delay={200} data-id="element-61">
            <div className="bg-luxury-white p-10 md:p-12 rounded-[2rem] border border-luxury-gold/20 relative overflow-hidden shadow-[0_0_40px_rgba(185,164,106,0.05)]" data-id="element-62">
              <div className="absolute top-0 left-0 w-full h-1 bg-luxury-gold" data-id="element-63" />
              <h3 className="text-sm font-medium text-luxury-gold uppercase tracking-widest mb-10 flex items-center gap-3" data-id="element-64">
                <span className="w-8 h-px bg-luxury-gold/50" data-id="element-65" />
                {t('baAfter')}
              </h3>
              <ul className="space-y-6" data-id="element-66">
                {afterItems.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-67">
                    <div className="mt-0.5 bg-luxury-gold/10 p-1 rounded-full shrink-0" data-id="element-68">
                      <CheckIcon className="w-4 h-4 text-luxury-gold" data-id="element-69" />
                    </div>
                    <span className="text-luxury-charcoal font-medium leading-relaxed" data-id="element-70">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}